import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './components/footer/footer.component';
import { MenuComponent } from './components/menu/menu.component';
import { FramePage } from './frame/frame.page';
import { HomeComponent } from './components/home/home.component';
import { FaleConoscoComponent } from './components/fale-conosco/fale-conosco.component';
import { CallToActionComponent } from './components/call-to-action/call-to-action.component';
import { FaqComponent } from './components/faq/faq.component';
import { AvaliacoesComponent } from './components/avaliacoes/avaliacoes.component';
import { AvaliacoesCardComponent } from './components/avaliacoes-card/avaliacoes-card.component';
import { TitleComponent } from './components/title/title.component';
import { ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MensagemErroFormComponent } from './components/menssagem-erro-form/mensagem-erro-form.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import localePt from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';

registerLocaleData(localePt);

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    MenuComponent,
    FramePage,
    HomeComponent,
    FaleConoscoComponent,
    CallToActionComponent,
    FaqComponent,
    AvaliacoesComponent,
    AvaliacoesCardComponent,
    TitleComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    MensagemErroFormComponent
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    {
      provide: LOCALE_ID,
      useValue: "pt-BR"
    },
    {
      provide: DEFAULT_CURRENCY_CODE,
      useValue: 'BRL'
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }